import { observable, configure, action, runInAction } from 'mobx';
import LocalModel from './localModel';
import util from '../lib/util';

configure({ enforceActions: 'always' });

class ScrapedContentStore extends LocalModel {
    constructor() {
        super('scrapedContent', {
            namePlural: 'scrapedContents',
            sort: '-scrapedDate',
            limit: 50,
            api: {
                search: {
                    url: '/api/scrapedcontent/admin',
                    params: {
                        limit: 50,
                        sort: '-scrapedDate',
                    },
                },
                load: {
                    url: '/api/scrapedcontent/admin',
                    params: {},
                },
                save: {
                    url: '/api/scrapedcontent/admin',
                    params: {},
                },
                delete: {
                    url: '/api/scrapedcontent/admin',
                    params: {},
                },
            },
        });
    }

    @observable scrapedContents = [];

    @action
    async rescrape(id) {
        const response = await util.fetchApi('/api/scrapedcontent/rescrape', { publish: true }, { id });
        if (response && response.status === 200) {
            // Refresh the page if callback is set
            if (this.refreshPage) {
                this.refreshPage();
            }
            return response.data;
        }
        throw new Error(response?.message || 'Failed to rescrape content');
    }
}

const store = new ScrapedContentStore();
export default store;
